// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiEndPoint: 'https://extranet.actudata.fr/api/', // http://dev.app.speedtarif.fr/api/
  apiKey: '0DZfzokzffz718840484fazzfafziojizfz4' // 0fb9e6c0e108ae053d652c4ed85ee84ee72733b8
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
